
import React, { Component } from 'react';

import '../styles/GenderAverages.css';

import donut from '../assets/icons8-doughnut-chart-40.png';
import podium from '../assets/icons8-leaderboard-26.png';

class GenderAverages extends Component {

  constructor(props) {
    super(props);
    let formalGender = 'female';
    if(this.props.gender === 'Men') formalGender = 'male';
    
    this.state = {
      gender: this.props.gender.toLowerCase(),
      genderFormal: formalGender
    }

    this.handleMeans = this.handleMeans.bind(this);
  }

  fixOurScore(scoreString) {
    if(!scoreString) return;
    let temp = scoreString.replace(' mins ', ':').replace(' min ', ':').replace(' secs', '');
    let tempArray = temp.split(':');

    if(!tempArray[1]) {
        tempArray = scoreString.split(' +');
      if (!tempArray[1]) {
        tempArray = scoreString.split('|');
      }
      return tempArray[0];
    }

    // time fix
    if(tempArray[1].length === 1) {
      tempArray[1] = '0' + tempArray[1];
    }

    return tempArray.join(':');
  }

  handleMeans() {
    if(!this.props.workoutObj.workout_stats) return;

    let number = this.props.workoutObj.workout_stats.means.prescribed[this.state.gender];

    if(number === 0) {
      number = 'NA';
    }
    if(!this.props.workoutObj.workout_stats.means.prescribed.units) {
      return number;
    } else if(this.props.workoutObj.workout_stats.means.prescribed.units === 'mins') {
      return number;
    } else {
      return number + ' ' + this.props.workoutObj.workout_stats.means.prescribed.units;
    }
  }

  render() {

    return(
      <div className={'relative flex items-center w-100 ' + (this.props.gender === 'Men' ? 'border-left-light-blue' : '')}>
        <h5 className={'absolute w-100 top-0 mv0 roboto transformY--50'}>
          <span className="relative white ph3 ttu">
            <i className={'fas fa-' + (this.props.gender === 'Men' ? 'male' : 'female') + ' f3 t-light-blue'}></i> 
            <span className="relative pl2 top-hack-gender">{this.props.gender}</span>
          </span>
        </h5>
        <div className="wrapper-container w-100">
          <div className="average flex items-center left">
            <span className="pre-line relative w-15"></span>
            <div className="ml1 w-15">
              <div className="aspect-ratio aspect-ratio--1x1" >
                <div className="cover aspect-ratio--object" style={{backgroundImage: 'url(' + donut + ')'}} ></div>
              </div> 
            </div>
            <span className="pl3 w-70 b tl">Average</span>
          </div>
          <div className="w-100 mt1 mb3">
            {this.props.workoutObj && 
              <div>
                {Object.keys(this.props.workoutObj).length > 0 && 
                  <span className="t-blue b">{
                    this.props.workoutObj.workout_stats ? this.handleMeans() : ''
                  }</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default GenderAverages;


// WEBPACK FOOTER //
// ./src/components/GenderAverages.js